<template>
  <div>
    <div class="discussContentBox" v-if="discuss">
   <div class="discussContentTtile">
     全部评论({{discuss.length}})
   </div>
   <div class="discussList" v-for="discuss in discuss" >
     <div class="discussAvataWrapper">
       <img :src="discuss.avatarUrl!=null&&discuss.avatarUrl!=''?discuss.avatarUrl:globalUrl + 'images/basicprofile.png'" class='discussAvata'>
     </div>
     <div class="discussContentWrapper">
       <div class="discussUserTitle" >{{discuss.nikeName!=null&&discuss.nikeName!=''?discuss.nikeName:'券粉'}}</div>
       <div class="discussUserContent" >
         <span class="replyTitle" v-if="discuss.discussType=='replay'">回复</span>
         <span class="cBlack" v-if="discuss.discussType=='replay'">{{discuss.replyNikeName!=null?discuss.replyNikeName+'：':'券粉：'}}</span>
         <span class="cBlack" >{{discuss.content}}</span>
       </div>
       <div class="discussUserDes">
         <span class="discussUserDesTime">{{discuss.createTime}}</span>
       </div>
     </div>
   </div>

 </div>
</div>
  </div>
</template>
<script type = "text/ecamscript-6">
import {getDateDiff,config} from  '../../common/js/common.js'
export default {
  name:"discuss",
  props:['getDiscuss','discuss'],
  data(){
    return{
     paperDiscuss:[],
     page:1,
     pageSize:10,
     globalUrl : config.gobalUrl
    }
  },
  created () {
    this.getDiscuss(0,this.page,this.pageSize)

  },
  methods:{

  }
}

</script>
<style  lang="stylus">
  .discussContentBox
    width: 100%
    box-sizing: border-box
    margin-top: 20px
    background: #fff
    padding: 30px 30px
    .discussContentTtile
      font-size: 28px
      color: #333
      padding-bottom: 25px
    .discussList
      display: flex
      justify-content: space-between
      margin-top: 25px
      .discussAvataWrapper
        flex: 0 0 80px
        .discussAvata
          width: 80px
          height: 80px
          display: block
          border-radius: 40px
      .discussContentWrapper
        flex: 1
        margin-left: 30px
        border-bottom: 1px solid #ddd
        /*px*/
        padding-bottom: 25px
        .discussUserTitle
          font-size: 24px
          color: #5176b3
          line-height: 26px
        .discussUserContent
          font-size: 28px
          color: #333
          margin-top: 25px
          position: relative
          .replyTitle
            font-size: 24px
            color: #5176b3
            line-height: 26px
          .cBlack
            color: #333
            width:100%
        .discussUserDes
          font-size: 24px
          color: #999
          display: flex
          justify-content: space-between
          margin-top: 25px
</style>



// WEBPACK FOOTER //
// src/components/quan/discuss.vue